import React from 'react';
import { motion } from 'framer-motion';

export const ProgressBar: React.FC<{ value?: number | null }> = ({ value }) => {
  const indeterminate = value === undefined || value === null;
  return (
    <div
      className={`v2-progress${indeterminate ? ' v2-progress--indeterminate' : ''}`}
      role="progressbar"
      aria-valuenow={indeterminate ? undefined : Math.round(value)}
    >
      {indeterminate ? (
        <div className="v2-progress-bar" />
      ) : (
        <motion.div
          className="v2-progress-bar"
          initial={{ width: 0 }}
          animate={{ width: `${Math.max(4, Math.min(100, value))}%` }}
          transition={{ type: 'spring', stiffness: 90, damping: 20 }}
        />
      )}
    </div>
  );
};

export const ProgressRing: React.FC<{ value: number; size?: number; stroke?: number; label?: React.ReactNode }> = ({
  value,
  size = 72,
  stroke = 7,
  label,
}) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const id = React.useId();
  return (
    <div className="v2-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" style={{ stopColor: 'var(--c-primary)' }} />
            <stop offset="100%" style={{ stopColor: 'var(--c-purple)' }} />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" style={{ stroke: 'rgba(29, 25, 39, 0.08)' }} strokeWidth={stroke} />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={`url(#${id})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c * (1 - Math.min(100, Math.max(0, value)) / 100) }}
          transition={{ type: 'spring', stiffness: 70, damping: 18 }}
        />
      </svg>
      <span className="v2-ring-label">{label ?? `${Math.round(value)}%`}</span>
    </div>
  );
};
